"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeb3 = exports.LocalProvider = void 0;
var localWeb3Context_1 = require("./localWeb3Context");
Object.defineProperty(exports, "LocalProvider", { enumerable: true, get: function () { return localWeb3Context_1.LocalProvider; } });
Object.defineProperty(exports, "useWeb3", { enumerable: true, get: function () { return localWeb3Context_1.useWeb3; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map